/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatCreditUsage } from "../funcs/chatCreditUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CreditUsageResponseBody } from "../models/components/creditusageresponsebody.js";
import {
  CreditUsageRequest,
  CreditUsageSecurity,
} from "../models/operations/creditusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetCreditUsageQueryData = CreditUsageResponseBody;

export function prefetchGetCreditUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request?: CreditUsageRequest | undefined,
  security?: CreditUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetCreditUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetCreditUsageQuery(
  client$: GramCore,
  request?: CreditUsageRequest | undefined,
  security?: CreditUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetCreditUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetCreditUsage({ gramSession: request?.gramSession }),
    queryFn: async function getCreditUsageQueryFn(
      ctx,
    ): Promise<GetCreditUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatCreditUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetCreditUsage(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "chat", "creditUsage", parameters];
}
